import { SaveActionButtonsComponent } from '../../../components/save-action-buttons/save-action-buttons.component';
import { SaveActionButton } from '../../../components/save-action-buttons/save-action-button.model';
import { DocumentDocFundingComponent } from './../../../components/document-conditions/document-doc-funding/document-doc-funding.component';
import { CommonModule } from '@angular/common';
import {
  Component,
  Injector,
  OnInit,
  Signal,
  ViewChild,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  FormsModule,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { CustomerService, PointOfSaleService } from '@digiwall/goliath-contacts/proxy';
import {
  CreateUpdateSalesPurchaseDto,
  CustomerDeliveryNoteService,
  CustomerDocDefaultValueDto,
  CustomerInvoiceLookupDto,
  CustomerInvoiceService,
  CustomerSalesPurchaseDto,
  DayBookService,
  CustomerSalesPurchaseService,
  Reserved,
  Deliverable,
  ReservationResult,
  ProductionFolderDocService,
} from '@digiwall/goliath-documents/proxy';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { Observable, concatMap, first, of } from 'rxjs';
import { AnnexesListComponent } from '@digiwall/goliath-core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ConfigStateService,
  LocalizationService,
  SubscriptionService,
  LocalizationModule,
} from '@abp/ng.core';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { BreadcrumbService } from 'xng-breadcrumb';
import {
  ClassificationTypeService,
  DocRole,
  LabelSubContext,
  WeightUnit,
} from '@digiwall/goliath-core/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';
import { DeliveryNoteCreationDialogComponent } from './delivery-note-creation-dialog/delivery-note-creation-dialog.component';
import { CustomerPreparationCreationDialogComponent } from './preparation-creation-dialog/customer-preparation-creation-dialog.component';
import { ReportViewerComponent } from '@odyssey/reporting';
import {
  conditionalValidator,
  DeactivatableComponentService,
  ChatComponent,
  DwDatePickerComponent,
  DwInputAutoCompleteDirective,
  HistoryComponent,
  NewId,
} from '@digiwall/core';
import { BaseCustomerDocDetail } from '../../base-customer-docs/base-customer-doc-detail';
import { FieldMapping } from '../../base-third-party-docs/base-third-party-doc-detail';
import { DocReportPermission } from '@digiwall/goliath-documents/config';
import {
  CounterComponent,
  DropdownMenu,
  DropdownMenuComponent,
  PanelComponent,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective, OffcanvasSize } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { DocCustomerAddressesComponent } from '../../base-docs/detail/doc-customer-addresses/doc-customer-addresses.component';
import { DocCustomerOthersComponent } from '../../base-docs/detail/doc-customer-others/doc-customer-others.component';
import { AsyncPipe } from '@angular/common';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { DepositInvoiceService } from '../services/deposit-invoice.service';
import { DocPricingService } from '../../../services/pricing/doc-pricing-service.service';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  BaseThirdPartyDocLineUpdatedDto,
  DocumentCoreCardComponent,
  DocumentCustomerCardComponent,
  DocumentCustomerDateCardComponent,
  DocumentCustomerStatusCardComponent,
  InvoiceTagComponent,
} from '../../../components';
import { LabelPrinterHelper } from '@digiwall/goliath-products';
import { NgSelectModule } from '@ng-select/ng-select';
import { SalesPurchaseDialogBoxCloneComponent } from './dialog-box-clone/dialog-box-clone.component';
import { CustomerSalesPurchaseLinesEditorComponent } from './customer-sales-purchase-lines/customer-sales-purchase-lines-editor.component';
import {
  ProductionFeatureDefinition,
  StockFeatureDefinition,
} from '@digiwall/goliath-products/config';
import { LogisticFeatureDefinition } from '@digiwall/goliath-documents/config';
import moment from 'moment';
import { ProformaComponent } from './generate-proforma/generate-proforma-dialog.component';
import { TextTemplateDto } from '@digiwall/core/proxy';
import { SendTextTemplateOptions } from '../../base-docs/detail/send-text-template-options';
import { FileInfoDto } from '@digiwall/file-management/proxy';
import { DocNumberTagComponent } from '../../../components/doc-number-tag/doc-number-tag.component';
import { ProductionDocCreationDialogComponent } from './production-doc-creation-dialog/production-doc-creation-dialog.component';

@Component({
  selector: 'document-customer-sales-purchase-details',
  templateUrl: './customer-sales-purchase-details.component.html',
  styleUrl: './customer-sales-purchase-details.component.scss',
  providers: [DocTemplateService],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    CustomerSalesPurchaseLinesEditorComponent,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocCustomerAddressesComponent,
    DocCustomerOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    DropdownMenuComponent,
    NgbNavOutlet,
    SaveActionButtonsComponent,
    SidePanelComponent,
    FormsModule,
    DialogBoxComponent,
    ReportViewerComponent,
    AsyncPipe,
    LocalizationModule,
    CounterComponent,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    DocumentCustomerCardComponent,
    DocumentCustomerDateCardComponent,
    DocumentCustomerStatusCardComponent,
    InvoiceTagComponent,
    DwDatePickerComponent,
    DwInputAutoCompleteDirective,
    NgSelectModule,
    HistoryComponent,
    DocNumberTagComponent,
    DocumentDocFundingComponent,
  ],
})
export class CustomerSalesPurchaseDetailsComponent
  extends BaseCustomerDocDetail<
    CustomerSalesPurchaseService,
    CustomerSalesPurchaseDto,
    CreateUpdateSalesPurchaseDto,
    CustomerDocDefaultValueDto
  >
  implements OnInit
{
  @ViewChild('salesPurchaseLineGrid') docLineGrid: CustomerSalesPurchaseLinesEditorComponent;
  @ViewChild('report') reportViewer: ReportViewerComponent;

  docRole = DocRole.CustomerSalesPurchase;

  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  protected readonly stockFeature = inject(StockFeatureDefinition);
  protected readonly logisticFeature = inject(LogisticFeatureDefinition);
  protected readonly productionFeature = inject(ProductionFeatureDefinition);

  override get defaultValue() {
    return Object.assign(this.baseDefaultValue, {
      allowPartialDelivery: false,
      allowOrderedQuantityOverrun: false,
    });
  }

  contactEmail: string;
  contactPhone: string;
  customerAddress: string;

  weightUnits = WeightUnit;

  totalAmount: number = 0;
  totalAmountVatIncluded: number = 0;

  hasRemainingInvoiceTermSlice$: Observable<boolean>;
  invoices$: Observable<CustomerInvoiceLookupDto[]>;

  protected saveActionBtns = computed(() => {
    let btns: SaveActionButton[] = [
      {
        label: this.localizationService.instant('::Save'),
        action: () => this.save(),
        // If not validated (draft), then you can always save
        // If validated (non-draft), then you can no longer save (validated auto)
        disabled: () =>
          !(
            // If draft -> can save
            (
              !this.isValidated() ||
              // Else NOT Draft
              // Must be dirty and linecount must be 0
              (this.form.dirty && this.lineCount() == 0)
            )
          ),
      },
    ];

    if (!this.isValidated()) {
      btns.push({
        label: this.localizationService.instant('Doc::SaveAsDraft'),
        action: () => this.saveAsDraft(),
        disabled: () => !this.form.dirty,
      });
    }
    return btns;
  });

  actions: Signal<DropdownMenu> = computed(() => ({
    groups: [
      this.baseActionsThirdPartyDoc().concat([
        {
          label: 'Doc::ImportDocTemplate',
          icon: 'digi-out-upload',
          action: () => this.importTemplate(),
        },
        {
          label: '::GeneratePdf',
          icon: 'digi-out-pdf-file',
          action: () => this.generatePdf(this.reportViewer),
        },
        {
          label: 'Doc::CustomerSalesPurchase:ToCustomerInvoice',
          icon: 'digi-out-add-file',
          action: () => this.toCustomerInvoice(),
        },
        {
          label: 'Doc::CustomerSalesPurchase:Proforma',
          icon: 'digi-out-add-file',
          action: () => this.generateProformaInvoice(),
        },
        this.productionFeature.isEnabled
          ? {
              label: 'Doc::CustomerSalesPurchase:GenerateProduction',
              icon: 'digi-out-production',
              action: () => this.generateProduction(),
              enabled: computed(() => this.isStockValidated()),
            }
          : null,
        {
          label: 'Doc::CustomerSalesPurchase:ToDeliveryNote',
          icon: 'digi-out-truck',
          action: () => this.toDeliveryNote(),
          enabled: computed(() => this.isStockValidated()),
        },
        this.logisticFeature.isEnabled
          ? {
              label: 'Doc::CustomerSalesPurchase:GeneratePreparation',
              icon: 'digi-out-checklist',
              action: () => this.generatePreparation(),
              enabled: computed(() => this.isStockValidated()),
            }
          : null,
        {
          label: '::Copy',
          icon: 'digi-out-copy',
          action: () => this.copy(),
        },
        {
          label: 'Doc::RecomputePrices',
          icon: 'digi-out-calculator',
          action: () => this.recomputePrices(),
          enabled: computed(() => !this.isClosed()),
        },
        this.stockFeature.isEnabled
          ? {
              label: 'Doc::StockReservation',
              icon: 'digi-out-bank-folder',
              action: () => this.stockReservation(),
              enabled: computed(() => this.isStockValidated() && this.lineCount() > 0),
            }
          : null,
      ]),
      [
        {
          label: 'Doc::PrintDocument',
          icon: 'digi-out-print',
          action: () => this.printDocument(),
          enabled: this.canPrintDocument,
        },
        {
          label: 'Doc::PrintLabel',
          icon: 'digi-out-print',
          action: () => this.printLabel(),
        },
      ],
      [
        {
          label: 'Doc::GenerateDocPrintTemplate',
          icon: 'digi-out-edit-square',
          action: () => this.openDesigner(),
          requiredPolicy: DocReportPermission.Create,
        },
        {
          label: 'Doc::GenerateLabelPrintTemplate',
          icon: 'digi-out-edit-square',
          action: () =>
            this.labelPrinterHelper.openDesigner(
              this.entity.id,
              LabelSubContext.CustomerDocOrderInfo,
            ),
        },
      ],
    ],
  }));

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    private salesPurchaseService: CustomerSalesPurchaseService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    injector: Injector,
    customerService: CustomerService,
    config: ConfigStateService,
    docTemplateService: DocTemplateService,
    classificationTypeService: ClassificationTypeService,
    protected confirmationService: ConfirmationService,
    protected pointOfSaleService: PointOfSaleService,
    private customerInvoiceService: CustomerInvoiceService,
    private customerDeliveryNoteService: CustomerDeliveryNoteService,
    deactivableComponentService: DeactivatableComponentService,
    private depositInvoiceService: DepositInvoiceService,
    private docPricingService: DocPricingService,
    protected labelPrinterHelper: LabelPrinterHelper,
    private productionFolderDocService: ProductionFolderDocService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      salesPurchaseService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      customerService,
      config,
      confirmationService,
      deactivableComponentService,
      labelPrinterHelper,
    );
  }

  private generateProformaInvoice() {
    const ref = this.offcanvasService.open(ProformaComponent, this.injector, {
      offcanvasPanelClass: OffcanvasSize.Medium,
    });
    let component: ProformaComponent = ref.componentInstance;
    component.customerSalesPurchaseReference = signal(this.entity.reference);
    component.customerSalesPurchaseId = signal(this.entity.id);
    component.textTemplates = this.textTemplates;
    component.currentPrintTemplateId = signal(this.form.get('preferredPrintTemplateId')?.value);

    ref.closed.subscribe((result: any) => {
      if (result != null) {
        this.toastService.success('Doc::CustomerSalesPurchase:ProformaGenerated');
        this.pdfProforma = result.proforma;
        this.getAnnexesCount(this.entity.id);
        if (result.sendEmail && result.textTemplateId) {
          let emailTemplate = this.textTemplates().find(x => x.id == result.textTemplateId);
          this.sendTextTemplate(emailTemplate, null);
        }
      }
    });
  }
  protected pdfProforma: FileInfoDto;

  protected override sendTextTemplate(
    textTemplate: TextTemplateDto,
    options: SendTextTemplateOptions,
  ): void {
    this.pdfAttachment = this.pdfProforma;
    this.pdfProforma = null;
    super.sendTextTemplate(textTemplate, options);
  }

  toCustomerInvoice() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }
    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      this.depositInvoiceService.createDepositInvoice(
        this.entity,
        this.languageCode,
        this.route,
        this.entity.documentDate,
        this.entity.dayBookId,
      );
    });
  }

  private toDeliveryNote() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }

    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      this.customerDeliveryNoteService
        .canCreateFromCustomerSalesPurchase(this.entity.id)
        .subscribeOnce(canCreate => {
          if (canCreate) {
            this.customerDeliveryNoteService
              .hasMissingDeposit(this.entity.id)
              .pipe(
                concatMap(hasMissingDeposit => {
                  if (hasMissingDeposit) {
                    return this.confirmationService.warn(
                      'Doc::CustomerSalesPurchase:CreateDeliveryNotWithMissingDeposit',
                      null,
                    );
                  }
                  return of(Confirmation.Status.confirm);
                }),
                concatMap(confirmationResult => {
                  const hasPositiveAmount =
                    this.entity.totalAmount != null && this.entity.totalAmount >= 0;

                  if (hasPositiveAmount || confirmationResult != Confirmation.Status.confirm)
                    return of(confirmationResult);

                  return this.confirmationService.warn(
                    'Doc::NegativeTotalAmount:ContinueQuestion',
                    '::AreYouSure',
                  );
                }),
                concatMap(confirmationResult => {
                  if (confirmationResult == Confirmation.Status.confirm) {
                    const canvaRef = this.offcanvasService.open(
                      DeliveryNoteCreationDialogComponent,
                      this.injector,
                      {
                        position: 'end',
                        panelClass: 'w-100 w-sm-75 ',
                      },
                    );
                    const deliveryNoteCreationComponent: DeliveryNoteCreationDialogComponent =
                      canvaRef.componentInstance as DeliveryNoteCreationDialogComponent;
                    deliveryNoteCreationComponent.salesPurchaseId = this.entity.id;
                    deliveryNoteCreationComponent.allowPartialDelivery.set(
                      this.form.get('allowPartialDelivery').value,
                    );
                    deliveryNoteCreationComponent.currencyPrecision = this.entity.currencyPrecision;

                    return deliveryNoteCreationComponent.docCreated;
                  }
                  return of(null);
                }),
              )
              .subscribeOnce(result => {
                if (result != null) {
                  const route =
                    result.docRole === DocRole.CustomerDeliveryNote
                      ? 'delivery-notes'
                      : 'customer-invoices';
                  this.router.navigate(['../../' + route, result.docId], {
                    queryParams: {
                      textTemplateId: result.textTemplateId,
                    },
                    relativeTo: this.route,
                  });
                }
              });
          }
        });
    });
  }

  protected recomputePrices() {
    this.docPricingService.recomputePrices(this.entity.id, this.salesPurchaseService, () => {
      this.refreshEntity();
      this.toastService.success('Doc::PriceRecomputed');
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  override get formModel() {
    return Object.assign({}, super.formModel, {
      //preferredDeliveryDate: [null],
      invoicingAddress_ThirdPartyAddressId: [null],
      interventionDate: [null],
      purchaseOrderStatusId: [null],
      allowOrderedQuantityOverrun: [false],
      requestedDeliveryDate: [
        null,
        conditionalValidator(
          () => this.form.get('documentDate')?.value,
          (control: AbstractControl): ValidationErrors | null => {
            const docDate = this.form?.get('documentDate')?.value;
            const deliveryDate = control.value;
            if (!docDate || !deliveryDate) return null;
            return moment(deliveryDate).isAfter(docDate, 'day')
              ? null
              : {
                  invalidDate: false,
                };
          },
        ),
      ],
      bankId: [null],
      personalContribution: [null],
      totalToBeFunded: [null],
      loanDuration: [null],
      loanRate: [null],
      monthlyPayment: [null],
    });
  }

  override copy() {
    const modalRef = this.modalService.open(SalesPurchaseDialogBoxCloneComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      scrollable: true,
      injector: this.injector,
      size: 'l',
    });
    modalRef.componentInstance.documentId = this.entity.id;
    modalRef.componentInstance.docService = this.docService;
    modalRef.componentInstance.isPriceComputationAvailable = true;
    this.annexes$?.subscribe(x => {
      modalRef.componentInstance.areAnnexesIncluded = x.length != 0;
    });
  }

  getEntityCallback(): void {
    super.getEntityCallback();

    super.loadThirdParties(this.entity.isClosed);

    this.hasRemainingInvoiceTermSlice$ = this.docService.nextInvoiceTermSlice(this.entity.id).pipe(
      first(),
      concatMap(nextInvoiceTermSlice => of(nextInvoiceTermSlice != null)),
    );

    this.invoices$ = this.customerInvoiceService.getBySalesPurchase(this.entity.id).pipe(first());

    this.docLineGrid?.lineGrid?.grid?.grid?.api?.redrawRows();
  }

  protected onThirdPartyChanged = (thirdPartyId: string): void => {
    super.onThirdPartyChanged(thirdPartyId);
    this.thirdPartyId$.next(thirdPartyId);
  };

  protected override refreshAfterLineUpdate(
    params: Partial<BaseThirdPartyDocLineUpdatedDto>,
  ): void {
    super.refreshAfterLineUpdate(params);

    if (params.extraProperties == null) return;
    const isReserved = params.extraProperties['isReserved'] as unknown as Reserved;
    if (isReserved != null) {
      this.entity.isReserved = isReserved;
    }
    const isDeliverable = params.extraProperties['isDeliverable'] as unknown as Deliverable;
    if (isDeliverable != null) {
      this.entity.isDeliverable = isDeliverable;
    }
  }

  protected override getFieldMappings(): FieldMapping[] {
    return [
      ...super.getFieldMappings(),
      { formField: 'representativeCommision', customerField: 'representativeCommission' },
    ];
  }

  viewInvoice(invoiceId: string) {
    this.router.navigate(['../../customer-invoices', invoiceId], { relativeTo: this.route });
  }

  protected stockReservation() {
    this.docService.reserve(this.entity.id).subscribeOnce(result => {
      this.refreshEntity();
      switch (result) {
        case ReservationResult.Reserved:
          this.toastService.success('Doc::CustomerSalesPurchase:ReservationSuccessful');
          break;
        case ReservationResult.PartiallyReserved:
          this.toastService.success('Doc::CustomerSalesPurchase:ReservationPartiallySuccessful');
          break;
        case ReservationResult.NothingToReserve:
          this.toastService.success('Doc::CustomerSalesPurchase:ReservationNothingToReserve');
          break;
        case ReservationResult.NotReserved:
        default:
          this.toastService.error('Doc::CustomerSalesPurchase:ReservationFailed');
          break;
      }
    });
  }

  protected override async afterGetEntity(response: CustomerSalesPurchaseDto): Promise<void> {
    await super.afterGetEntity(response);
    this.subscribeToFormValueChanges();
  }

  protected override afterSave(): void {
    super.afterSave();
    this.subscribeToFormValueChanges();
  }

  private generatePreparation() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }

    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      const canvasRef = this.offcanvasService.open(
        CustomerPreparationCreationDialogComponent,
        this.injector,
        {
          position: 'end',
          panelClass: 'w-100 w-sm-75',
        },
      );
      const preparationCreationComponent: CustomerPreparationCreationDialogComponent =
        canvasRef.componentInstance as CustomerPreparationCreationDialogComponent;
      preparationCreationComponent.customerSalePurchaseId = this.entity.id;

      canvasRef.closed.subscribeOnce(result => {
        if (result != null) {
          this.refreshEntity();
        }
      });
    });
  }

  private generateProduction() {
    if (this.form.get('isBlocked').value) {
      this.isBlockedError();
      return;
    }

    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.formStateService.checkDirtyForm(this.form, () => {
      this.productionFolderDocService
        .canCreateFromCustomerSalesPurchase(this.entity.id)
        .subscribeOnce(canCreate => {
          if (!canCreate) return;
          const canvaRef = this.offcanvasService.open(
            ProductionDocCreationDialogComponent,
            this.injector,
            {
              position: 'end',
              panelClass: 'w-100 w-sm-75 ',
            },
          );
          const productionCreateComponent: ProductionDocCreationDialogComponent =
            canvaRef.componentInstance as ProductionDocCreationDialogComponent;
          productionCreateComponent.salesPurchaseId = this.entity.id;

          canvaRef.closed.subscribeOnce(result => {
            if (result != null) {
              this.router.navigate(['/', 'production', 'folder-docs', result.id]);
            }
          });
        });
    });
  }

  public override canDeactivate = async () => {
    if (
      this.isValidated() &&
      this.lineCount() > 0 &&
      (this.form.dirty || !this.isStockValidated())
    ) {
      this.canDeactivateTitle = 'Doc::CustomerQuote:NotValidatedWishToContinue';
    } else {
      this.canDeactivateTitle = null;
    }
    return !this.form.dirty;
  };
}
